document.addEventListener('DOMContentLoaded', () => {
  const priceFormatter = price => new Intl.NumberFormat(document.documentElement.lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price);
  const calculateSubtotal = (item) => {
    if (!document.querySelector('.calculated-sub-total')) {
      return;
    }

    const quantity = parseInt(item.value, 10);
    if (Number.isNaN(quantity)) {
      return;
    }
    const price = parseFloat(item.getAttribute('data-price-for-subtotal'));
    if (Number.isNaN(price)) {
      return;
    }

    const priceVat = parseFloat(item.getAttribute('data-price-for-subtotal-vat'));
    if (Number.isNaN(price)) {
      return;
    }

    const subtotal = priceFormatter(Math.round(quantity * price * 100) / 100);
    const subtotalVat = priceFormatter(Math.round(quantity * priceVat * 100) / 100);

    document.querySelectorAll('[data-price-for-subtotal]')
      .forEach((input) => {
        input.value = quantity;
      });
    document.querySelectorAll('.calculated-sub-total')
      .forEach((wrapper) => {
        wrapper.innerHTML = subtotal;
      });

    document.querySelectorAll('.calculated-sub-total-vat')
      .forEach((wrapper) => {
        wrapper.innerHTML = subtotalVat;
      });
  };

  if (document.querySelector('.singleProduct-shop')) {
    const priceWrapSelector = '#price-wrap';
    const cachedPriceHtml = document.querySelector(priceWrapSelector).innerHTML;
    const stockWrapSelector = '#stock-wrap';
    const cachedStockHtml = document.querySelector(stockWrapSelector).innerHTML;
    const priceCalculatorSelector = '[data-price-for-subtotal]';
    const cachedPriceCalculatorSelector = document.querySelector(priceCalculatorSelector).getAttribute('data-price-for-subtotal');
    
    jQuery('form.cart')
      .on('show_variation', (event, data) => {
        if (data.price_html_to_replace) {
          document.querySelector(priceWrapSelector).innerHTML = data.price_html_to_replace;
        }
        if (data.stock_status_html) {
          document.querySelector(stockWrapSelector).innerHTML = data.stock_status_html;
        }
        if (data.quantity_min_max) {
          document.querySelector(stockWrapSelector).innerHTML = data.stock_status_html;
        }
        document.querySelector(priceCalculatorSelector).setAttribute('data-price-for-subtotal', data.price_to_calculate);
        document.querySelector('[data-price-for-subtotal]').value = 1;
        calculateSubtotal(document.querySelector('[data-price-for-subtotal]'));
        document.querySelector('.quantity-min-max').innerHTML = data.quantity_min_max;
      })
      .on('hide_variation', () => {
        document.querySelector(priceWrapSelector).innerHTML = cachedPriceHtml;
        document.querySelector(stockWrapSelector).innerHTML = cachedStockHtml;
        document.querySelector(priceCalculatorSelector).setAttribute('data-price-for-subtotal', cachedPriceCalculatorSelector);
        document.querySelector('[data-price-for-subtotal]').value = 1;
        calculateSubtotal(document.querySelector('[data-price-for-subtotal]'));
        document.querySelector('.quantity-min-max').innerHTML = document.querySelector('.quantity-min-max').getAttribute('data-quantity-min-max');
      });
  }

  document.querySelectorAll('[data-price-for-subtotal]')
    .forEach((item) => {
      item.addEventListener('change', () => {
        calculateSubtotal(item);
      });
    });
  calculateSubtotal(document.querySelector('[data-price-for-subtotal]'));
});
